import React, { useEffect } from 'react';
import LayoutOne from '../../layouts/LayoutOne';
import { useDispatch, useSelector } from 'react-redux';
import { getBranchs } from '../../store/actions/Branch';

const Branches = () => {
  const branchs = useSelector((state) => state.branchs.list)
  console.log(branchs)
  const dispatch = useDispatch()
  useEffect(() => {
    const fetchBranchs = async () => {
      await dispatch(getBranchs())
    }
    fetchBranchs()
  }, [dispatch])
  const staticBranches = [
    {
      name: "Varachha Branch",
      image: "assets/img/svg/Iphone12White.jpg"
    },
    {
      name: "Katargam Branch",
      image: "assets/img/svg/Iphone12Blue.jpg"
    },
    {
      name: "Hirabaugh Branch",
      image: "assets/img/svg/Iphone12Red.jpg"
    }
  ];

  // Normalize static names for matching
  const normalizeName = (name) => name.toLowerCase().replace(/\s+/g, "").replace("branch", "");

  const mergedBranches = branchs
    .filter((branch) => branch.status === 1)
    .map((branch) => {
      const matchedStatic = staticBranches.find(staticBranch =>
        normalizeName(staticBranch.name).includes(normalizeName(branch.name))
      );

      return {
        id: branch._id,
        name: branch.name,
        address: branch.address,
        phone: "+91 7896541230", // You can customize if needed
        image: matchedStatic?.image,
        location: branch.location
      };
    });


  return (
    <LayoutOne>

      <div className="container-fluid py-5" style={{ backgroundColor: "#ffffff" }}>
        <div className="row justify-content-center mt-5">
          {mergedBranches.map((branch) => (
            <div
              key={branch.id}
              className="col-lg-4 col-md-6 mb-4 d-flex justify-content-center"
            >
              <div
                className="card h-100"
                style={{
                  width: "100%",
                  maxWidth: "400px",
                  border: "none",
                  borderRadius: "12px",
                  boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                  overflow: "hidden",
                  transition: "transform 0.3s ease",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
              >
                <img
                  src={branch.image}
                  alt={branch.name}
                  className="card-img-top"
                  style={{
                    height: "230px",
                    objectFit: "cover",
                    borderBottom: "1px solid #ddd",
                  }}
                />
                <div
                  className="card-body d-flex flex-column justify-content-between"
                  style={{
                    backgroundColor: "#ffffff",
                    padding: "20px",
                  }}
                >
                  <h5
                    className="card-title text-center mb-3"
                    style={{
                      fontSize: "1.1rem",
                      fontWeight: "600",
                      color: "#222",
                      textTransform: "uppercase",
                      borderBottom: "1px solid #e0e0e0",
                      paddingBottom: "10px",
                    }}
                  >
                    {branch.name}
                  </h5>

                  <p
                    className="card-text mb-4"
                    style={{
                      fontSize: "0.95rem",
                      color: "#555",
                      textAlign: "justify",
                      minHeight: "100px",
                    }}
                  >
                    {branch.address}
                  </p>

                  <div
                    className="d-flex justify-content-between align-items-center mt-auto"
                    style={{ borderTop: "1px solid #eee", paddingTop: "15px" }}
                  >
                    <a
                      href={`tel:${branch.phone}`}
                      className="text-decoration-none"
                      style={{
                        color: "#0d6efd",
                        fontWeight: "500",
                        fontSize: "0.95rem",
                      }}
                    >
                      📞 {branch.phone}
                    </a>
                    <a
                      href={branch.location}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-decoration-none"
                      style={{
                        color: "#28a745",
                        fontWeight: "500",
                        fontSize: "0.95rem",
                      }}
                    >
                      📍 View Map
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </LayoutOne>
  );
};

export default Branches;